<template>
  <vx-card no-shadow>

    <vs-input type="password" class="w-full mb-base" label-placeholder="Password Baru" v-model="model.pass1" />
    <vs-input type="password" class="w-full mb-base" label-placeholder="Konfirmasi Password" v-model="model.pass2" />

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" @click="updatePassword()">Save Changes</vs-button>
    </div>
  </vx-card>
</template>

<script>
import user from "@/api/user.js";

export default {
  data() {
    return {
      model: {
          pass1: '',
          pass2: ''
      }
    }
  },
    methods: {
        updatePassword() {
            user.myresetpassword(this.model, {
                headers: {
                    "content-type": "application/json"
                }
            }).then(response => {
                this.model = {
                    pass1: '',
                    pass2: ''
                };

                if (response.data.status) {
                    this.$vs.notify({
                        title: "Info",
                        time: 3000,
                        text:
                            "Data telah berhasil di submit",
                        color: "success",
                        position: "top-right"
                    });
                } else {
                    this.$vs.notify({
                        title:
                            "Terjadi Kesalahan",
                        time: 3000,
                        text: response.data.message,
                        color: "danger",
                        position: "top-right"
                    });
                }
            });
        }
    }
}
</script>
